import React from 'react'

import PropTypes from 'prop-types'

import {
  TextField,
  Button,
} from '@material-ui/core'
import styles from "./Position.module.css";

class PositionForm extends React.Component {
  render () {
    return (
      <div>
        <form>
          <TextField
            autoComplete="off"
            variant="outlined"
            className={styles.textFields}
            size="small"
            name="name"
            fullWidth
            label="Name"
            onChange={this.props.onchange}
            value={this.props.item.name}
            id="position-name"
          />
          <p className={styles.error}>{this.props.error}</p>
        </form>
        <div className={styles.actionButton}>
          <Button variant="outlined" disabled={!this.props.item.name} name="position-submit" id="position-submit" color="primary" onClick={() => this.props.submit()} >Save</Button>
        </div>
      </div>
    )
  }
}
export default PositionForm

PositionForm.propTypes = {
  onchange: PropTypes.func,
  item: PropTypes.object,
  children: PropTypes.object,
  error: PropTypes.string,
  submit: PropTypes.func
}
